import axios from 'axios';
import {
    GET_ERRORS,
    PAGE_ERRORS,
    GET_PAGE,
    GET_SECURED_PAGES,
    GET_MENU_PAGES,
    GET_PAGES,
    PAGES_LOADING,
    RESET_PAGES,
    GET_CONTENT_ROWS,
    GET_CONTENT_ROW,
} from './types';
import { ToastsStore } from 'react-toasts';
import { resetErrors } from './errorsActions';

//GET PAGES
export const getPages = () => (dispatch) => {
    dispatch(setPagesLoading());
    dispatch(resetErrors);

    axios
        .get('/api/pages')
        .then((res) => {
            dispatch({
                type: GET_PAGES,
                payload: res.data,
            });
            dispatch({
                type: GET_PAGES,
                payload: res.data,
            });
        })
        .catch((err) => {
            dispatch({ type: GET_ERRORS, payload: err.response.data });
        });
};

export const getPublicPages = () => (dispatch) => {
    dispatch(setPagesLoading());
    dispatch(resetErrors());
    axios
        .get('/api/public/pages')
        .then((res) => {
            dispatch({ type: GET_PAGES, payload: res.data });
        })
        .catch((err) => {
            dispatch({ type: GET_ERRORS, payload: err.response.data });
        });
};

export const getPublicPage = (page) => (dispatch) => {
    dispatch(setPagesLoading());
    dispatch(resetErrors());
    axios
        .get(`/api/public/page/${page}`)
        .then((res) => {
            dispatch({ type: GET_PAGE, payload: res.data });
        })
        .catch((err) => {
            dispatch({ type: GET_ERRORS, payload: err.response.data });
        });
};

export const getPublicMenu = () => (dispatch) => {
    dispatch(setPagesLoading());
    dispatch(resetErrors);

    axios
        .get(`/api/public/menu`)
        .then((res) => {
            dispatch({
                type: GET_MENU_PAGES,
                payload: res.data,
            });
        })
        .catch((err) => {
            if (err) {
                if (err.response) {
                    if (err.response.data) {
                        dispatch({
                            type: GET_ERRORS,
                            payload: err.response.data,
                        });
                    }
                }
            }
        });
};

export const getPrivateMenu = () => (dispatch) => {
    dispatch(setPagesLoading());
    dispatch(resetErrors);

    axios
        .get(`/api/pages/menu`)
        .then((res) => {
            dispatch({
                type: GET_MENU_PAGES,
                payload: res.data,
            });
        })
        .catch((err) => {
            if (err) {
                if (err.response) {
                    if (err.response.data) {
                        dispatch({
                            type: GET_ERRORS,
                            payload: err.response.data,
                        });
                    }
                }
            }
        });
};
//GET PAGES
export const getSecuredPages = () => (dispatch) => {
    dispatch(setPagesLoading());
    dispatch(resetErrors);

    axios
        .get('/api/pages/secured')
        .then((res) => {
            dispatch({
                type: GET_SECURED_PAGES,
                payload: res.data,
            });
        })
        .catch((err) => {
            if (err) {
                if (err.response) {
                    if (err.response.data) {
                        dispatch({
                            type: GET_ERRORS,
                            payload: err.response.data,
                        });
                    }
                }
            }
        });
};

//GET PAGE
export const getPage = (page_id) => (dispatch) => {
    dispatch(setPagesLoading());
    dispatch(resetErrors);

    axios
        .get('/api/pages/' + page_id)
        .then((res) => {
            dispatch({
                type: GET_PAGE,
                payload: res.data,
            });
        })
        .catch((err) => {
            dispatch({ type: GET_ERRORS, payload: err.response.data });
        });
};

export const getDynamicPage = (page_id) => (dispatch) => {
    dispatch(setPagesLoading());
    dispatch(resetErrors);

    axios
        .get('/api/pages/dynamic-app-page/' + page_id)
        .then((res) => {
            dispatch({
                type: GET_PAGE,
                payload: res.data,
            });
        })
        .catch((err) => {
            dispatch({ type: GET_ERRORS, payload: err?.response?.data });
        });
};

export const editLandingPage = (page_id) => (dispatch) => {
    dispatch(setPagesLoading());
    dispatch(resetErrors);

    axios
        .post('/api/pages/change-landing-page', { page_id })
        .then((res) => {
            dispatch(getPages());
        })
        .catch((err) => {
            dispatch({ type: GET_ERRORS, payload: err.response.data });
        });
};

export const createContentRow = (data, history) => (dispatch) => {
    dispatch(setPagesLoading());
    dispatch(resetErrors);

    const { page } = data;

    axios
        .post(`/api/pages/rows/${page}`, data)
        .then((res) => {
            history.push(`/settings/pages/${page}/view`);
        })
        .catch((err) => {
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data,
            });
        });
};

export const editContentRow = (page, row, data, history) => (dispatch) => {
    dispatch(setPagesLoading());
    dispatch(resetErrors);

    const { page } = data;
    axios
        .post(`/api/pages/rows/${page}/${row}`, data)
        .then((res) => {
            history.push(`/settings/pages/view/${page}`);
        })
        .catch((err) => {
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data,
            });
        });
};

export const getContentRows = (page) => (dispatch) => {
    dispatch(setPagesLoading());
    dispatch(resetErrors);

    axios
        .get(`/api/pages/rows/${page}`)
        .then((res) => {
            dispatch({
                type: GET_CONTENT_ROWS,
                payload: res.data,
            });
        })
        .catch((err) => {
            dispatch({ type: GET_ERRORS, payload: err.response.data });
        });
};

export const getContentRow = (page, row) => (dispatch) => {
    dispatch(setPagesLoading());
    dispatch(resetErrors);

    axios
        .get(`/api/pages/rows/${page}/${row}`)
        .then((res) => {
            dispatch({
                type: GET_CONTENT_ROW,
                payload: res.data,
            });
        })
        .catch((err) => {
            dispatch({ type: GET_ERRORS, payload: err.response.data });
        });
};

//CREATE PAGE
export const createPage = (pageData, history) => (dispatch) => {
    dispatch(setPagesLoading());
    dispatch(resetErrors);

    axios
        .post('/api/pages/create', pageData)
        .then(() => {
            ToastsStore.success(`Page created successfully`);
            history.goBack();
        })
        .catch((err) => {
            dispatch({ type: PAGE_ERRORS, payload: err.response?.data });
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data,
            });
        });
};


// EDIT PAGE
export const editPage = (page_id, pageData, history) => (dispatch) => {
    dispatch(resetErrors);

    axios
        .post('/api/pages/' + page_id, pageData)
        .then((res) => {
            ToastsStore.success(`${res.data.title} updated successfully`);
            history.push(`/settings/pages/view/${page_id}`);
        })
        .catch((err) => {
            dispatch({ type: PAGE_ERRORS, payload: err.response?.data });

            dispatch({
                type: GET_ERRORS,
                payload: err.response.data,
            });
        });
};

//DELETE CONTENT ROW AND OBJECTS WITHIN IT
export const deleteContentRow = (page, row) => (dispatch) => {
    dispatch(resetErrors);

    axios
        .delete(`/api/pages/rows/${page}/${row}`)
        .then((res) => {
            dispatch(getPage(page));
            ToastsStore.success(
                'Row and all associated objects deleted successfully'
            );
        })
        .catch((err) => {
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data,
            });
        });
};

export const setPage = (page) => {
    return { type: GET_PAGE, payload: page };
};

export const setPagesLoading = () => {
    return { type: PAGES_LOADING };
};

export const resetPages = () => {
    return { type: RESET_PAGES };
};
